























































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import {
  assignVendor, getOrder, adminUpdate, getOrderHistory,
  getOrderViewReport, getOrderQAReport,
  eligibilityReport, regenerateReport, downloadPdfReport, downloadXmlReport,
  getOrderCantFinishInspection,
  downloadFreddieMacJson, getOrderJsonResponse //, getOrderFreddieMacReport
} from '@/api/orders'
import { AppModule } from '@/store/modules/app'
import { TagsViewModule, ITagView } from '@/store/modules/tags-view'
import { OrdersModule, defaultOrderData } from '@/store/modules/orders'
import Sticky from '@/components/Sticky/index.vue'
import { Form } from 'element-ui'
import AvmDetail from './AvmDetail.vue'
import ChangeStatus from './ChangeStatus.vue'
import OrderInformation from './OrderInformation.vue'
import OrderContact from './OrderContact.vue'
import OrderProperty from './OrderProperty.vue'
import OrderHistoryTable from './OrderHistoryTable.vue'
import OrderViewReport from './OrderViewReport.vue'
import VueJsonViewer from 'vue-json-viewer'
import { IChangeStatus, IOrderHistoryData, IFixRequest, IOrderData } from '@/api/types'
import { OrderStatusEnum } from '@/api/enums'
import { UserModule } from '@/store/modules/user'
import VendorCreate from './VendorCreate.vue'
import VendorInformation from '@/views/vendors/components/VendorInformation.vue'
import VendorData from '@/views/vendors/components/VendorData.vue'
import { getVendor } from '@/api/vendors'
import { IVendor } from '@/api/types-vendor'
import FixRequestDialog from './FixRequestDialog.vue'

@Component({
  name: 'OrderDetail',
  components: {
    AvmDetail,
    ChangeStatus,
    OrderInformation,
    OrderContact,
    OrderProperty,
    OrderHistoryTable,
    OrderViewReport,
    VendorCreate,
    Sticky,
    VueJsonViewer,
    VendorInformation,
    VendorData,
    FixRequestDialog
  }
})
export default class extends Vue {
  @Prop({ default: false }) private isEdit!: boolean
  componentKey = 1
  private orderForm = Object.assign({}, defaultOrderData)
  private loading = false
  private isCompleted = false
  private userListOptions = []
  private dialogChangeStatusVisible = false
  private dialogFixRequestVisible = false
  private dialogJsonVisible = false
  private dialogJsonFreddieMacVisible = false
  private freddieMacJsonData = ''
  private dialogHistoryVisible = false
  private dialogViewReportVisible = false
  private dialogViewQAVisible = false
  private dialogViewFreddieMacVisible = false
  private dialogConfirmVendorFee = false
  private dialogEditReportVisible = false
  private orderViewReport = ''
  private orderHistory: IOrderHistoryData[] = []
  private sectionURL = ''
  private sectionName = ''
  private sectionGroup = ''
  private sectionNumber = ''
  private orderQAReport = ''
  private orderFreddieMacReport = ''
  private newVendorId = null
  private newVendor: IVendor | null = null
  private prevVendorFee: number | null = null
  private generateReportTimeOut = 180000
  private showBlazor = true

  private editReport(section: string, sectionGroup: string, sectionNumber: string) {
    this.sectionURL = ''
    this.sectionName = section
    this.sectionGroup = sectionGroup
    this.sectionNumber = sectionNumber
    let useJWT = false

    // handle editor form dialogs here.
    switch (section) {
      // Classic
      case 'exterior':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/exterior/report/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'interior':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/interior/report/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'floor':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/floors/report/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'photos':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/photos/report/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'photoTable':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/photos/table/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'uploadphoto':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/photos/upload/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'replacephoto':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/photos/replace/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'deletephoto':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/photos/delete/${this.orderForm.orderId}/${this.sectionGroup}`
        break

      // PDR
      case 'siteAmenity':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/site-amenity/report/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'utility':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/utility/report/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'carstorage':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/carstorage/report/${this.orderForm.orderId}/${this.sectionGroup}`
        break
      case 'structure':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/structure/report/${this.orderForm.orderId}/${this.sectionGroup}/${this.sectionNumber}`
        break
      case 'unit':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/unit/report/${this.orderForm.orderId}/${this.sectionGroup}/${this.sectionNumber}/1`
        break
      case 'unit-floor':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/unit-floor/report/${this.orderForm.orderId}/${this.sectionGroup}/${sectionNumber}/1/1`
        break
      case 'unit-room':
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/unit-room/report/${this.orderForm.orderId}/${this.sectionGroup}/${sectionNumber}`
        break

      // Freddie Mac and Fannie Mae
      case 'freddie-mac':
        this.sectionName = ''
        this.sectionURL = `${process.env.VUE_APP_BASE_API}api/v1/content/freddie-mac/status/${this.orderForm.orderId}/${this.sectionGroup}`
        break

      // Blazor
      case 'orderBlazor':
        useJWT = true
        this.sectionURL = `${process.env.VUE_APP_BASE_BLAZOR}Orders/Order/Edit/${this.orderForm.orderId}`
        console.log('Generated URL:', this.sectionURL)
        break
      case 'propertyBlazor':
        useJWT = true
        this.sectionURL = `${process.env.VUE_APP_BASE_BLAZOR}Orders/Order/Property/${this.orderForm.orderId}`
        console.log('Generated URL:', this.sectionURL)
        break
      case 'featuresBlazor':
        useJWT = true
        this.sectionURL = `${process.env.VUE_APP_BASE_BLAZOR}Orders/Order/Features/${this.orderForm.orderId}`
        console.log('Generated URL:', this.sectionURL)
        break
      case 'hudBlazor':
        useJWT = true
        this.sectionURL = `${process.env.VUE_APP_BASE_BLAZOR}Orders/Order/HUD/${this.orderForm.orderId}`
        console.log('Generated URL:', this.sectionURL)
        break
    }

    this.sectionURL += '/' + Math.round(new Date().getTime() / 1000)
    if (useJWT) {
      this.sectionURL += `/${encodeURI(this.getJWTToken())}/`
    }
    this.dialogEditReportVisible = true
  }

  private handleReportMenuCommand = (command: string | number | object) => {
    switch (command) {
      case 'v':
        return this.viewReport() // Quick Report View
      case 'q':
        return this.viewQAReport() // QA Report View
      case 'd': // Download Latest PDF
        return this.downloadReport()
      case 'x': // Download XML
        return this.downloadXml()
      case 'h': // History View
        return this.viewHistory()
      case 'j': // JSON View
        return this.viewJson()
      case 'f': // JSON Freddie Mac View
        return this.viewJsonFreddieMac('PDR')
      case 'fr': // JSON Freddie Mac Response html report
        return this.viewFreddieMacReport('PDR')

      case 'fm': // JSON Fannie Mae Response html report
        return this.viewFreddieMacReport('FannieMae')
      case 'fmj': // JSON Fannie Mae View
        return this.viewJsonFreddieMac('FannieMae')
      case 'fmer': // Download the Eligibility Report for Freddie Mac PDF
        return this.downloadEligibilityReport(false, 'FannieMae')
      case 'fmegr': // Generate the Eligibility Report for Freddie Mac PDF
        return this.downloadEligibilityReport(true, 'FannieMae')

      case 'r': // regenerate PDF
        return this.downloadRegenerateReport()
      case 'ljr':
        return this.getJsonResponse()
      case 'er': // Download the Eligibility Report for Freddie Mac PDF
        return this.downloadEligibilityReport(false, 'PDR')
      case 'egr': // Generate the Eligibility Report for Freddie Mac PDF
        return this.downloadEligibilityReport(true, 'PDR')
    }
  }

  private handleEditMenuCommand = (command: string | number | object) => {
    switch (command) {
      case 'createFixRequest':
        return this.createFixRequest()
      case 'createChangeStatus':
        return this.createChangeStatus()
      case 'Exterior':
        return this.editReport('exterior', 'Capture', '')
      case 'Interior':
        return this.editReport('interior', 'Capture', '')
      case 'Floors':
        return this.editReport('floor', 'Capture', '')
      case 'Photos':
        return this.editReport('photos', 'Capture', '')
      case 'PhotoTable':
        return this.editReport('photoTable', 'Capture', '')
      case 'UploadPhoto':
        return this.editReport('uploadphoto', 'Capture', '')
      case 'ReplacePhoto':
        return this.editReport('replacephoto', 'Capture', '')
      case 'DeletePhoto':
        return this.editReport('deletephoto', 'Capture', '')
      case 'OrderBlazor':
        return this.editReport('orderBlazor', 'PDR', '')
      case 'PropertyBlazor':
        return this.editReport('propertyBlazor', 'PDR', '')
      case 'FeaturesBlazor':
        return this.editReport('featuresBlazor', 'PDR', '')
      case 'HUDBlazor':
        return this.editReport('hudBlazor', 'PDR', '')
      case 'Structure':
        return this.editReport('structure', 'PDR', '1')
      case 'Site Amenity':
        return this.editReport('siteAmenity', 'PDR', '')
      case 'Car Storage':
        return this.editReport('carstorage', 'PDR', '')
      case 'Utility':
        return this.editReport('utility', 'PDR', '')
      case 'Units':
        return this.editReport('unit', 'PDR', '1')
      case 'Unit Floors':
        return this.editReport('unit-floor', 'PDR', '1')
      case 'Unit Rooms':
        return this.editReport('unit-room', 'PDR', '1')
      case 'cfi':
        return this.getCantFinishInspectionDocuments()
    }
  }

  private async handleCloseEditor() {
    this.loading = true
    await this.fetchData(this.orderForm.orderId)
    this.loading = false
    this.$notify({
      title: 'Success',
      message: `${this.sectionGroup} saved for ${this.orderForm.orderId}.`,
      type: 'success',
      duration: 1000
    })
    return false
  }

  private validateRequire = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      if (rule.field === 'imageURL') {
        this.$message({
          message: 'Upload cover image is required',
          type: 'error'
        })
      } else {
        this.$message({
          message: rule.field + ' is required',
          type: 'error'
        })
      }
      callback(new Error(rule.field + ' is required'))
    } else {
      callback()
    }
  }

  private title(name: string) {
    return `Order ${name} ${this.orderForm.orderId}`
  }

  private rules = {
    title: [{ validator: this.validateRequire }]
  }

  private tempTagView?: ITagView

  get lang() {
    return AppModule.language
  }

  created() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id
      this.fetchData(parseInt(id))
    }
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route)
  }

  private isAdmin() {
    const roles = UserModule.roles
    return roles.includes('Admin')
  }

  private isClientSuperUser() {
    const roles = UserModule.roles
    return roles.includes('ClientSuperUser')
  }

  private getJWTToken() : string {
    return UserModule.email
  }

  private updateData(order: IOrderData) {
    this.orderForm = order
  }

  private async fetchData(id: number) {
    try {
      const { data } = await getOrder(id)
      this.componentKey = +id
      this.orderForm = data
      OrdersModule.setSelectedOrder(this.orderForm)
      this.isCompleted = this.orderForm.orderStatusId === OrderStatusEnum.QASubmitted

      const title = 'Edit Order ' + this.orderForm.orderId
      // Set tagsview title
      this.setTagsViewTitle(title)
      // Set page title
      this.setPageTitle(title)
    } catch (err) {
      console.error(err)
    }
  }

  private setTagsViewTitle(title: string) {
    const tagView = this.tempTagView
    if (tagView) {
      tagView.title = title
      TagsViewModule.updateVisitedView(tagView)
    }
  }

  private setPageTitle(title: string) {
    document.title = title
  }

  showAvmSummary() {
    if (this.orderForm === undefined) return false
    if (this.orderForm?.avmData !== null) return true
    if (this.orderForm.product === null) return false
    return this.orderForm?.product.avmReportAddOn !== 'None'
  }

  private closeTagView() {
    const tagView = this.tempTagView
    if (tagView) {
      TagsViewModule.delView(tagView)
      this.toLastView(TagsViewModule.visitedViews, tagView)
    }
  }

  private toLastView(visitedViews: ITagView[], view: ITagView) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView !== undefined && latestView.fullPath !== undefined) {
      this.$router.push(latestView.fullPath).catch(err => {
        console.warn(err)
      })
    } else {
      // Default redirect to the home page if there is no tags-view, adjust it if you want
      if (view.name === 'Dashboard') {
        // to reload home page
        this.$router.replace({ path: '/redirect' + view.fullPath }).catch(err => {
          console.warn(err)
        })
      } else {
        this.$router.push('/').catch(err => {
          console.warn(err)
        })
      }
    }
  }

  private forceRerender() {
    this.componentKey += 1
  }

  private getNewVendor(vendorId: number) {
    getVendor(vendorId).then((result: any) => {
      this.newVendor = result.data
    })
  }

  private confirmationVendorFee() {
    this.prevVendorFee = this.orderForm.vendorFee
    this.dialogConfirmVendorFee = true
  }

  private submitForm() {
    (this.$refs.orderForm as Form).validate(async valid => {
      if (valid) {
        if (this.orderForm.vendorFee < 0) {
          this.$notify({
            title: 'Error',
            message: 'Vendor Fee can\'t be a negative number',
            type: 'error',
            duration: 5000
          })
          return false
        }
        // Clean phone number for API consumption
        if (this.orderForm.contactPhone) {
          this.orderForm.contactPhone = this.orderForm.contactPhone.replace(/\D/g, '')
        }
        if (this.orderForm.contactPhone2) {
          this.orderForm.contactPhone2 = this.orderForm.contactPhone2.replace(/\D/g, '')
        }
        this.updateOrder()
      } else {
        console.log('Validation errors!')
        return false
      }
    })
  }

  private closeModal() {
    this.orderForm.vendorFee = this.prevVendorFee
    this.dialogConfirmVendorFee = false
  }

  private async updateOrder() {
    this.dialogConfirmVendorFee = false
    this.loading = true
    const updatedOrder = await adminUpdate(this.orderForm.orderId, this.orderForm)
    if (updatedOrder) {
      // re-fetch the order
      this.orderForm = updatedOrder
      // await this.fetchData(this.orderForm.orderId)
      OrdersModule.updateOrder(this.orderForm)

      this.loading = false
      this.$notify({
        title: 'Success',
        message: `Order ${this.orderForm.orderId} saved successfully.`,
        type: 'success',
        duration: 2000
      })
      this.closeTagView()
      return true
    } else { // , () => {
      // Server Error!? is displayed in request.ts
      console.log('Server-side error!')
      this.forceRerender()
    }

    // END ADD NEW ORDER
    //
  }

  private cancelForm() {
    this.closeTagView()
    return true
  }

  private updateVendor(vendorId: number) {
    this.newVendorId = vendorId
    this.confirmationVendorFee()
  }

  private async handleAssignVendor(vendorId: number) {
    console.log(`handling Assign Vendor: ${vendorId}`)
    this.loading = true

    if (this.orderForm.vendorFee < 0) {
      this.$notify({
        title: 'Error',
        message: 'Vendor Fee can\'t be a negative number',
        type: 'error',
        duration: 5000
      })
      this.loading = false
      return
    }

    this.dialogConfirmVendorFee = false
    assignVendor({ orderId: this.orderForm.orderId, vendorId: vendorId, vendorFee: this.orderForm.vendorFee }).then(() => {
      // re-fetch the order
      this.fetchData(this.orderForm.orderId).then(() => {
        this.loading = false
        this.newVendorId = null
        this.newVendor = null
        console.log(`OrderEdit after fetchData() after assign VendorId: ${vendorId}, Order.VendorId: ${this.orderForm.vendorId}`);

        (this.$refs.VendorCreateRef as any).newVendor = 0
        this.$notify({
          title: 'Success',
          message: `Vendor (${this.orderForm.vendorId}) Assigned to ${this.orderForm.orderId} successfully.`,
          type: 'success',
          duration: 6000
        })
      }, (error2) => {
        console.log(`Fetch Data Server-side error! ${error2}`)
      })
    }, (error) => {
    // Server Error!? is displayed in request.ts
      console.log(`Assign Vendor Server-side error! ${error}`)
    })
    this.forceRerender()
    this.loading = false
    return false
  }

  private async handleViewReport() {
    await this.getPdfReport()
  }

  private viewJson() {
    console.log(`view Json for order: ${this.orderForm.orderId}`)
    this.dialogJsonVisible = true
  }

  private getJson() {
    return this.orderForm
  }

  private viewJsonFreddieMac(sectionGroup: string) {
    console.log(`view ${sectionGroup} Json for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.dialogJsonFreddieMacVisible = true
      this.getJsonFreddieMac(sectionGroup)
    }
  }

  private async getJsonFreddieMac(sectionGroup: string) {
    console.log(`Before fetching ${sectionGroup} Json  for order ${this.orderForm.orderId}`)
    const response = (await downloadFreddieMacJson(this.orderForm.orderId))
    this.freddieMacJsonData = response.data
    this.loading = false
  }

  private getJsonFreddieMacData() {
    return this.freddieMacJsonData
  }

  private viewFreddieMacReport(sectionGroup: string) {
    console.log(`view ${sectionGroup} Status for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.getFreddieMacReport(sectionGroup)
    }
  }

  private async getFreddieMacReport(sectionGroup: string) {
    console.log(`Before loading ${sectionGroup} Report for order ${this.orderForm.orderId}`)
    return this.editReport('freddie-mac', sectionGroup, '1')
  }

  private getListLoading() {
    return this.loading
  }

  private viewHistory() {
    console.log(`view History for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.dialogHistoryVisible = true
      this.getHistory()
    }
  }

  private async getHistory() {
    this.loading = true
    console.log(`Before loading History for order ${this.orderForm.orderId}`)
    const response = (await getOrderHistory(this.orderForm.orderId))
    this.orderHistory = response.data
    this.loading = false
  }

  private createFixRequest() {
    console.log(`Fix request for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.fixRequest = this.initFixRequest()
      this.dialogFixRequestVisible = true
    }
  }

  handleFixRequestDialogClose() {
    this.dialogFixRequestVisible = false
  }

  private createChangeStatus() {
    console.log(`Change Status for: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.changeStatus = this.initChangeStatus()
      this.dialogChangeStatusVisible = true
    }
  }

  handleChangeStatusDialogClose() {
    this.dialogChangeStatusVisible = false
  }

  fixRequest: IFixRequest = {
    orderId: this.orderForm.orderId,
    modelId: null, // this.orderForm.floorPlan.modelId,
    attachment: null,
    instructions: ''
  }

  initFixRequest(): IFixRequest {
    const modelId = this.orderForm.floorPlan ? this.orderForm.floorPlan.modelId : ''
    console.log(`Floorplan model ${modelId}`)
    return {
      orderId: this.orderForm.orderId,
      modelId: modelId,
      attachment: null,
      instructions: ''
    }
  }

  changeStatus: IChangeStatus = {
    orderId: this.orderForm.orderId,
    currentStatus: this.orderForm.orderStatus,
    newStatus: null,
    message: ''
  }

  initChangeStatus(): IChangeStatus {
    return {
      orderId: this.orderForm.orderId,
      currentStatus: this.orderForm.orderStatus,
      newStatus: null,
      message: ''
    }
  }

  private viewReport() {
    console.log(`view Report for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.dialogViewReportVisible = true
      this.getViewReport()
    }
  }

  private async getViewReport() {
    this.loading = true
    console.log(`Before loading Report for order ${this.orderForm.orderId}`)
    const response = (await getOrderViewReport(this.orderForm.orderId))
    this.orderViewReport = response.data
    this.loading = false
  }

  private viewQAReport() {
    console.log(`view QA Report for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.dialogViewQAVisible = true
      this.getQAReport()
    }
  }

  private async getQAReport() {
    this.loading = true
    console.log(`Before loading QA Report for order ${this.orderForm.orderId}`)
    const response = (await getOrderQAReport(this.orderForm.orderId))
    this.orderQAReport = response.data
    this.loading = false
  }

  private async downloadReport() {
    console.log(`view Report for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.getPdfReport()
    }
  }

  private async downloadRegenerateReport() {
    console.log(`view Report for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.getRegeneratedReport()
    }
  }

  private async downloadEligibilityReport(generateMe: boolean, sectionGroup: string) {
    console.log(`view ${sectionGroup} Eligibility Report for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.getEligibilityReport(generateMe, sectionGroup)
    }
  }

  private async downloadXml() {
    console.log(`view XML for order: ${this.orderForm.orderId}`)
    if (this.orderForm.orderId) {
      this.getXmlReport()
    }
  }

  private async getJsonResponse() {
    this.loading = true
    const notifyInstance = this.$notify({
      title: `Downloading ${this.orderForm.orderId} JSON Response`,
      message: 'Fetching your JSON... Please wait.',
      duration: 0,
      type: 'info',
      onClose: this.closedNotify
    })
    console.log(`Before downloading JSON Response for order ${this.orderForm.orderId}`)
    const response = (await getOrderJsonResponse(this.orderForm.orderId))

    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink2 = document.createElement('a')

    fileLink2.href = fileURL
    fileLink2.setAttribute('download', `${this.orderForm.orderId}-response.json`)
    document.body.appendChild(fileLink2)

    notifyInstance.close()

    fileLink2.click()
    this.loading = false
  }

  private async getPdfReport() {
    this.loading = true
    const notifyInstance = this.$notify({
      title: `Downloading ${this.orderForm.orderId} Pdf Report`,
      message: 'Building your report... Please wait.',
      duration: 0,
      type: 'info',
      onClose: this.closedNotify
    })
    console.log(`Before downloading Pdf Report for order ${this.orderForm.orderId}`)
    const response = (await downloadPdfReport(this.orderForm.orderId))

    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink = document.createElement('a')

    fileLink.href = fileURL
    fileLink.setAttribute('download', `${this.orderForm.orderId}.pdf`)
    document.body.appendChild(fileLink)

    notifyInstance.close()

    fileLink.click()
    this.loading = false
  }

  private async getEligibilityReport(generateMe: boolean, sectionGroup: string) {
    this.loading = true
    const notifyInstance = this.$notify({
      title: `Downloading ${sectionGroup} ${this.orderForm.orderId}  Eligibility Pdf Report`,
      message: `Downloading ${sectionGroup} Eligibility report... It will be regenerated if needed. Please wait.`,
      duration: 0,
      type: 'info',
      onClose: this.closedNotify
    })
    console.log(`Before Getting Eligibility Report for order ${this.orderForm.orderId}`)
    const response = (await eligibilityReport(this.orderForm.orderId, generateMe))

    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink = document.createElement('a')

    fileLink.href = fileURL
    fileLink.setAttribute('download', `${this.orderForm.orderId}-${sectionGroup}-eligibility.pdf`)
    document.body.appendChild(fileLink)

    notifyInstance.close()

    fileLink.click()
    this.loading = false
  }

  private async getRegeneratedReport() {
    this.loading = true
    const notifyInstance = this.$notify({
      title: `Regenerating ${this.orderForm.orderId} Pdf Report`,
      message: 'Please wait...',
      duration: 0,
      type: 'info',
      onClose: this.closedNotify
    })
    try {
      console.log(`Before Regenerating Pdf Report for order ${this.orderForm.orderId}`)
      const response = (await regenerateReport(this.orderForm.orderId, { timeout: this.generateReportTimeOut }))

      const fileURL = window.URL.createObjectURL(new Blob([response.data]))
      const fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.setAttribute('download', `${this.orderForm.orderId}-r.pdf`)
      document.body.appendChild(fileLink)

      notifyInstance.close()

      fileLink.click()
    } catch (error) {
      console.error('Error while regenerating the report:', error)
      notifyInstance.close()
    } finally {
      this.loading = false
    }
  }

  private async getXmlReport() {
    this.loading = true
    const notifyInstance = this.$notify({
      title: `Downloading ${this.orderForm.orderId} Xml`,
      message: 'Fetching your Xml... Please wait.',
      duration: 0,
      type: 'info',
      onClose: this.closedNotify
    })
    console.log(`Before downloading XML for order ${this.orderForm.orderId}`)
    const response = (await downloadXmlReport(this.orderForm.orderId))

    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink = document.createElement('a')

    fileLink.href = fileURL
    fileLink.setAttribute('download', `${this.orderForm.orderId}.xml`)
    document.body.appendChild(fileLink)

    notifyInstance.close()

    fileLink.click()
    this.loading = false
  }

  private closedNotify() {
    this.loading = false
  }

  private async getCantFinishInspectionDocuments() {
    this.loading = true
    const notifyInstance = this.$notify({
      title: `Downloading ${this.orderForm.orderId} Supporting Documents`,
      message: 'Fetching your documents... Please wait.',
      duration: 0,
      type: 'info',
      onClose: this.closedNotify
    })
    console.log(`Before loading can't finish inspection documents for order ${this.orderForm.orderId}`)
    const response = (await getOrderCantFinishInspection(this.orderForm.orderId))

    const fileURL = window.URL.createObjectURL(new Blob([response.data]))
    const fileLink2 = document.createElement('a')

    fileLink2.href = fileURL
    fileLink2.setAttribute('download', `${this.orderForm.orderId}-response.zip`)
    document.body.appendChild(fileLink2)

    notifyInstance.close()

    fileLink2.click()
  }
}
